import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

// Components
import SelectButton from './SelectButton';

const OrganizationFilters = ({
	orgFilters,
	onChangeOrgFilters,
	organizations,
	workspaces,
	modules,
	cycles
}) => {
	const { global_data } = useSelector(state => state.global);
	const { isAdminUser } = useSelector(state => state.auth);

	// Filter workspaces by value === 2 only if user is not admin
	const filteredWorkspaces = !Array.isArray(workspaces)
		? []
		: isAdminUser
			? workspaces
			: workspaces.filter(ws => ws.value === 2);

	return (
		<Fragment>
			<div className='d-flex row align-items-center justify-content-center mt-4 mb-3'>
				{organizations.length > 1 &&
					<SelectButton
						label={global_data?.organizationTerms?.organization}
						options={organizations !== undefined ? organizations : ['No organizations']}
						name='organization'
						value={orgFilters.organization ? orgFilters.organization : null}
						onChange={onChangeOrgFilters}
						disable={false}
						icon='house'
						orgFilter={true}
					/>
				}
				<SelectButton
					label={global_data?.organizationTerms?.workspace}
					options={filteredWorkspaces.length > 0 ? filteredWorkspaces : []}
					name='workspace'
					value={orgFilters.workspace ? orgFilters.workspace : null}
					onChange={onChangeOrgFilters}
					disable={orgFilters.organization === '' ? true : false}
					icon='list'
					orgFilter={true}
				/>
			</div>
			<div className='d-flex row align-items-center justify-content-center mb-4'>
				<SelectButton
					label={global_data?.organizationTerms?.module}
					options={modules !== undefined ? modules : ['No modules']}
					name='module'
					value={orgFilters.module === '' ? null : orgFilters.module}
					onChange={onChangeOrgFilters}
					disable={orgFilters.workspace === '' ? true : false}
					icon='box2'
					orgFilter={true}
				/>
				<SelectButton
					label={global_data?.organizationTerms?.cycle}
					options={cycles !== undefined ? cycles : ['No cycles']}
					name='cycle'
					value={orgFilters.cycle === '' ? null : orgFilters.cycle}
					onChange={onChangeOrgFilters}
					disable={orgFilters.module === '' ? true : false}
					icon='arrow-repeat'
					orgFilter={true}
				/>
			</div>
		</Fragment>
	);
}

export default OrganizationFilters;
